import React from "react";
import { LegalLayout, LegalSection } from "@/components/LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout
      testid="privacy-policy-page"
      title="Privacy Policy"
      intro="Your privacy matters to us. This policy explains what we collect and how we protect it."
    >
      <LegalSection heading="Information Collection">
        We collect customer names, shipping addresses, email addresses, phone numbers, and IP addresses solely for order processing and site functionality.
      </LegalSection>
      <LegalSection heading="Data Security">
        Payment card details are tokenized and processed directly by Sagicor's PCI-DSS compliant payment gateway.
      </LegalSection>
      <LegalSection heading="Third-Party Sharing">
        We do not sell, rent, or lease customer data to third parties. Data is shared only with payment gateways and fulfillment carriers strictly to execute transactions.
      </LegalSection>
      <LegalSection heading="Contact">
        For privacy concerns, reach out to talenteduniquerebel@gmail.com.
      </LegalSection>
    </LegalLayout>
  );
}
